<template>
    <footer class="no-print">
        <div class="footer-content">
            <div class="footer-top">
                <img alt="Esenda logo" :src="logo" />

                <div class="footer-link-container">
                    <slot name="links" />
                </div>
            </div>

            <hr />

            <div class="footer-bottom">
                <div class="footer-company-info-container">
                    <p>
                        {{ t("companyInfo.registeredCountries") }}<br />
                        {{ t("companyInfo.companyNumber") }} 10800880
                    </p>

                    <p>
                        124 City Road<br />
                        London<br />
                        EC1V 2NX
                    </p>
                </div>

                <span>&copy; esenda {{ new Date().getFullYear() }}</span>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import esendaLogoSvg from "@/assets/logos/Esenda_logo_white.svg";
import { useI18n } from "vue-i18n";

const logo = esendaLogoSvg;

const { t } = useI18n();
</script>

<style scoped>
footer {
    color: var(--white);
    background-image: linear-gradient(
        90deg,
        var(--gradient-brand) 0%,
        var(--footer-gradient-end) 100%
    ) !important;
}

img {
    width: 70px;
    margin-bottom: 2rem;
}

hr {
    border-color: color-mix(in srgb, var(--footer-link) 24%, transparent);
}

p {
    font-size: 14px;
    color: var(--footer-text-dimmed);
}

span {
    color: var(--footer-text-dimmed);
}

:deep(a) {
    font-weight: bold;
}

.footer-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    padding: 2rem 1rem;
}

.footer-top,
.footer-bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.footer-bottom {
    gap: 1rem;
}

.footer-link-container {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
}

.footer-company-info-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

@media (min-width: 600px) {
    img {
        width: 100px;
        height: auto;
    }

    .footer-content {
        padding: 2rem;
    }
}

@media (min-width: 960px) {
    span {
        align-self: flex-start;
    }

    .footer-content {
        margin: auto;
        padding: 2rem 10%;
    }

    .footer-bottom {
        flex-direction: row;
    }
}

@media (min-width: 1200px) {
    .footer-content {
        max-width: 60%;
        padding: 2rem 0;
    }
}
</style>
